import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export const fetch = (params = {}, rest = {}) =>
    axios
        .get('/itinerary', {
            params,
            ...rest,
        })
        .then(({ data }) => {
            if (data && typeof data === 'object' && Array.isArray(data.items) && data.items[0]) {
                return data.items;
            }

            throw new ApiRequestError('Failed fetch itineraries /itinerary', {
                params,
                rest,
            });
        });

export const fetchBySlug = (slug, rest = {}) =>
    axios
        .get('/itinerary', {
            params: {
                slug,
            },
            ...rest,
        })
        .then(({ data }) => {
            if (data && typeof data === 'object' && Array.isArray(data.items) && data.items[0]) {
                return data.items[0];
            }

            throw new ApiRequestError('Failed fetchBySlug itineraries /itinerary', {
                slug,
                rest,
            });
        });
